import { ref, computed } from 'vue'
import { useAuthStore } from '../stores/auth'
import { isAccountBlockedRoute } from '../utils/accountBlockedRoutes'

const inPageActive = ref(false)
const inPageReason = ref('self')
const modalVisible = ref(false)
const ownerAccessBlocked = ref(false)

export function setOwnerAccessBlocked (value) {
  ownerAccessBlocked.value = Boolean(value)
}

export function useAccountAccessBlock () {
  const authStore = useAuthStore()

  const isExempt = computed(() => authStore.user?.role?.nome === 'SUPER_ADMIN')

  const isSelfBlocked = computed(() =>
    !isExempt.value && Boolean(authStore.user?.acessoBloqueado)
  )

  const isOwnerBlocked = computed(() =>
    !isExempt.value && ownerAccessBlocked.value
  )

  const isBlocked = computed(() => isSelfBlocked.value || isOwnerBlocked.value)

  const openModal = () => {
    if (isExempt.value) return
    if (isSelfBlocked.value) {
      modalVisible.value = true
    }
  }

  const closeModal = () => {
    modalVisible.value = false
  }

  const openInPageBlock = () => {
    if (isExempt.value) return false
    if (isSelfBlocked.value) {
      inPageReason.value = 'self'
      inPageActive.value = true
      return true
    }
    if (isOwnerBlocked.value) {
      inPageReason.value = 'owner'
      inPageActive.value = true
      return true
    }
    return false
  }

  const closeInPageBlock = () => {
    inPageActive.value = false
  }

  const shouldBlockNavigation = (path) => {
    if (isExempt.value) return false
    if (!isAccountBlockedRoute(path)) return false
    return isSelfBlocked.value || isOwnerBlocked.value
  }

  const shouldBlockDashboardAction = (workspace) => {
    if (isExempt.value) return false
    if (isSelfBlocked.value) return true
    if (workspace?.criador?.acessoBloqueado) return true
    return false
  }

  const checkRouteOnLoad = (path) => {
    if (!shouldBlockNavigation(path)) {
      closeInPageBlock()
      return false
    }
    openInPageBlock()
    return true
  }

  return {
    inPageActive,
    inPageReason,
    modalVisible,
    ownerAccessBlocked,
    isExempt,
    isSelfBlocked,
    isOwnerBlocked,
    isBlocked,
    openModal,
    closeModal,
    openInPageBlock,
    closeInPageBlock,
    shouldBlockNavigation,
    shouldBlockDashboardAction,
    checkRouteOnLoad,
    setOwnerAccessBlocked
  }
}
